import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../hooks/useApi';
import Icon from '../components/Icon';

// ─── GROUPES DE CHAMPS ────────────────────────

const GROUPES_KETCHUP = [
  { key: 'pate_tomate_cans',  label: 'Pâte de tomate (cans 156ml)', unite: 'cans' },
  { key: 'vinaigre_cidre_k',  label: 'Vinaigre de cidre de pomme', unite: 'ml' },
  { key: 'vinaigre_blanc_k',  label: 'Vinaigre blanc', unite: 'ml' },
  { key: 'miel_k',            label: 'Miel', unite: 'ml' },
  { key: 'eau_k',             label: 'Eau', unite: 'ml' },
  { key: 'onion_k',           label: 'Onion granulé', unite: 'ml' },
  { key: 'ail_k',             label: 'Ail granulé', unite: 'ml' },
  { key: 'sel_kasher_k',      label: 'Sel Kasher', unite: 'ml' },
  { key: 'sel_celeri_k',      label: 'Sel de céleri', unite: 'ml' },
  { key: 'paprika_k',         label: 'Paprika fumé', unite: 'ml' },
  { key: 'sauce_soya_k',      label: 'Sauce soya', unite: 'ml' },
  { key: 'cassonade_k',       label: 'Cassonade', unite: 'ml' },
  { key: 'tallow_k',          label: 'Tallow fumé', unite: 'ml' },
  { key: 'rendement_ketchup_ml', label: 'Rendement ketchup estimé', unite: 'ml' },
];

const GROUPES_GASTRIQUE = [
  { key: 'vinaigre_cidre_s',  label: 'Vinaigre de cidre de pomme', unite: 'ml' },
  { key: 'sucre_canne_s',     label: 'Sucre de canne biologique', unite: 'ml' },
  { key: 'cassonade_s',       label: 'Cassonade', unite: 'ml' },
  { key: 'worcestershire_s',  label: 'Sauce Worcestershire', unite: 'ml' },
  { key: 'sauce_soya_s',      label: 'Sauce soya', unite: 'ml' },
];

const GROUPES_EPICES = [
  { key: 'sel_kasher_s',      label: 'Sel Kasher', unite: 'ml' },
  { key: 'poivre_s',          label: 'Poivre moulu', unite: 'ml' },
  { key: 'poivre_blanc_s',    label: 'Poivre blanc', unite: 'ml' },
  { key: 'chili_s',           label: 'Poudre de Chili', unite: 'ml' },
  { key: 'ail_s',             label: 'Ail granulé', unite: 'ml' },
  { key: 'onion_s',           label: 'Onion granulé', unite: 'ml' },
  { key: 'epices_jamaique_s', label: 'Épices de Jamaïque', unite: 'ml' },
  { key: 'cumin_s',           label: 'Cumin', unite: 'ml' },
];

const GROUPES_CORPS = [
  { key: 'miel_s',            label: 'Miel', unite: 'ml' },
  { key: 'eau_s',             label: 'Eau', unite: 'ml' },
  { key: 'bourbon_s',         label: 'Bourbon américain', unite: 'ml' },
  { key: 'rendement_sauce_ml', label: 'Rendement sauce estimé', unite: 'ml' },
];

const GROUPES_PRIX = [
  { key: 'prix_pot_250ml',    label: 'Prix pot 250ml', unite: '$' },
  { key: 'prix_pot_350ml',    label: 'Prix pot 350ml', unite: '$' },
];

// ─── COMPOSANT GROUPE ─────────────────────────

function GroupeChamps({ titre, champs, form, onChange }) {
  return (
    <div style={{ padding: 'var(--space-4)', borderTop: '1px solid var(--border)' }}>
      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.10em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 'var(--space-3)' }}>
        {titre}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 'var(--space-3)' }}>
        {champs.map(({ key, label, unite }) => (
          <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
            <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-soft)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
              {label}
            </label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <input
                type="number"
                step="0.1"
                min="0"
                style={{
                  flex: 1,
                  background: 'var(--bg)',
                  border: '1px solid var(--border)',
                  borderRadius: 'var(--radius-md)',
                  padding: '7px 10px',
                  color: 'var(--text)',
                  fontSize: 13,
                  outline: 'none',
                }}
                value={form[key] ?? ''}
                onChange={e => onChange(key, e.target.value)}
                onFocus={ev => (ev.target.style.borderColor = 'var(--accent)')}
                onBlur={ev => (ev.target.style.borderColor = 'var(--border)')}
              />
              <span className="muted" style={{ fontSize: 11, whiteSpace: 'nowrap' }}>{unite}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── PAGE ─────────────────────────────────────

export default function RecetteSauce() {
  const [recette, setRecette]   = useState(null);
  const [form, setForm]         = useState({});
  const [historique, setHistorique] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [saving, setSaving]     = useState(false);
  const [message, setMessage]   = useState(null);

  useEffect(() => {
    Promise.all([
      api.get('/sauce/recette'),
      api.get('/sauce/batches'),
    ]).then(([rRecette, rBatches]) => {
      setRecette(rRecette);
      setForm(rRecette);
      setHistorique(rBatches?.filter(b => b.statut === 'finalise') || []);
    }).catch((err) => {
      console.error('[RecetteSauce] Erreur chargement :', err?.response?.data || err?.message);
    }).finally(() => setLoading(false));
  }, []);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setMessage(null);
    try {
      await api.put('/sauce/recette', form);
      setMessage({ type: 'success', text: 'Recette sauvegardée comme défaut.' });
    } catch (err) {
      setMessage({ type: 'danger', text: err.response?.data?.error || err.message });
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return (
      <div style={{ padding: 'var(--space-7) var(--space-6)', maxWidth: 880, margin: '0 auto' }}>
        <div className="skeleton" style={{ height: 44, maxWidth: 360, marginBottom: 'var(--space-4)' }} />
        <div className="skeleton" style={{ height: 300, marginBottom: 'var(--space-4)' }} />
      </div>
    );
  }

  if (!recette) {
    return (
      <div style={{ padding: 'var(--space-7) var(--space-6)', maxWidth: 880, margin: '0 auto' }}>
        <div className="error-inline">
          <Icon name="erreur" size={16} /> Recette introuvable.
        </div>
      </div>
    );
  }

  const yieldMoyen = historique.length > 0
    ? Math.round(historique.reduce((s, b) => s + (parseFloat(b.yield_sauce) || 0), 0) / historique.length * 10) / 10
    : null;

  return (
    <div style={{ padding: 'var(--space-7) var(--space-6) var(--space-8)', maxWidth: 880, margin: '0 auto' }}>

      {/* En-tête */}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 'var(--space-7)', gap: 'var(--space-4)' }}>
        <div>
          <h1 style={{ fontFamily: "'Cinzel', serif", fontSize: 28, fontWeight: 600, color: 'var(--text)', letterSpacing: '0.04em', lineHeight: 1.1, margin: '0 0 var(--space-2)' }}>
            Recette — Sauce BBQ Miel &amp; Bourbon
          </h1>
          <div style={{ width: 32, height: 1, background: 'var(--accent)', opacity: 0.7, marginBottom: 'var(--space-2)' }} />
          <p className="muted" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.05em', margin: 0 }}>
            Quantités par batch (multiplicateur × 1)
          </p>
        </div>
        <Link to="/production/sauce" className="btn btn-ghost btn--sm">
          <Icon name="retour" size={13} /> Retour production
        </Link>
      </div>

      {/* KPIs yield */}
      {yieldMoyen !== null && (
        <div className="card rise-in" style={{ marginBottom: 'var(--space-5)', display: 'flex', gap: 'var(--space-7)' }}>
          <div>
            <div style={{ fontFamily: "'Cinzel', serif", fontSize: 28, fontWeight: 600, color: 'var(--accent)', fontFeatureSettings: "'tnum' 1" }}>{yieldMoyen}%</div>
            <div style={{ fontSize: 10, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 2 }}>Yield moyen</div>
          </div>
          <div>
            <div style={{ fontFamily: "'Cinzel', serif", fontSize: 28, fontWeight: 600, color: 'var(--text)', fontFeatureSettings: "'tnum' 1" }}>{historique.length}</div>
            <div style={{ fontSize: 10, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 2 }}>Batches finalisés</div>
          </div>
        </div>
      )}

      {/* Formulaire */}
      <form onSubmit={handleSubmit}>
        {/* Section Ketchup maison */}
        <div className="card" style={{ marginBottom: 'var(--space-4)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)', paddingBottom: 'var(--space-3)', borderBottom: '1px solid var(--border)', marginBottom: 0 }}>
            <span style={{ color: 'var(--muted)', display: 'flex', alignItems: 'center' }}>
              <Icon name="sauce" size={16} />
            </span>
            <span style={{ fontFamily: "'Cinzel', serif", fontSize: 13, fontWeight: 600, color: 'var(--text-soft)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Ketchup Maison
            </span>
          </div>
          <GroupeChamps titre="Ingrédients ketchup" champs={GROUPES_KETCHUP} form={form} onChange={set} />
        </div>

        {/* Section Sauce BBQ */}
        <div className="card" style={{ marginBottom: 'var(--space-4)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)', paddingBottom: 'var(--space-3)', borderBottom: '1px solid var(--border)', marginBottom: 0 }}>
            <span style={{ color: 'var(--muted)', display: 'flex', alignItems: 'center' }}>
              <Icon name="fumage" size={16} />
            </span>
            <span style={{ fontFamily: "'Cinzel', serif", fontSize: 13, fontWeight: 600, color: 'var(--text-soft)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Sauce BBQ Miel &amp; Bourbon
            </span>
          </div>
          <GroupeChamps titre="Gastrique" champs={GROUPES_GASTRIQUE} form={form} onChange={set} />
          <GroupeChamps titre="Épices" champs={GROUPES_EPICES} form={form} onChange={set} />
          <GroupeChamps titre="Corps" champs={GROUPES_CORPS} form={form} onChange={set} />
        </div>

        {/* Section Prix */}
        <div className="card" style={{ marginBottom: 'var(--space-4)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)', paddingBottom: 'var(--space-3)', borderBottom: '1px solid var(--border)', marginBottom: 0 }}>
            <span style={{ color: 'var(--muted)', display: 'flex', alignItems: 'center' }}>
              <Icon name="argent" size={16} />
            </span>
            <span style={{ fontFamily: "'Cinzel', serif", fontSize: 13, fontWeight: 600, color: 'var(--text-soft)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Prix par défaut
            </span>
          </div>
          <GroupeChamps titre="Tarifs" champs={GROUPES_PRIX} form={form} onChange={set} />
        </div>

        {/* Message feedback */}
        {message && (
          <div style={{ marginBottom: 'var(--space-3)' }}>
            {message.type === 'danger'
              ? <div className="error-inline"><Icon name="erreur" size={15} />{message.text}</div>
              : <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)', padding: '10px 12px', borderRadius: 'var(--radius-md)', background: 'color-mix(in srgb, var(--success) 10%, transparent)', border: '1px solid color-mix(in srgb, var(--success) 30%, transparent)', color: 'var(--success)', fontSize: 13 }}>
                  <Icon name="succes" size={15} />{message.text}
                </div>
            }
          </div>
        )}

        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving
            ? 'Sauvegarde...'
            : <><Icon name="sauvegarder" size={14} /> Sauvegarder comme recette par défaut</>}
        </button>
      </form>

      {/* Historique batches */}
      {historique.length > 0 && (
        <div className="card rise-in" style={{ marginTop: 'var(--space-7)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)', marginBottom: 'var(--space-5)', paddingBottom: 'var(--space-3)', borderBottom: '1px solid var(--border)' }}>
            <span style={{ color: 'var(--muted)', display: 'flex', alignItems: 'center' }}>
              <Icon name="liste" size={16} />
            </span>
            <span style={{ fontFamily: "'Cinzel', serif", fontSize: 13, fontWeight: 600, color: 'var(--text-soft)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Historique des batches
            </span>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table className="esc-table">
              <thead>
                <tr>
                  <th>Batch</th>
                  <th>Date</th>
                  <th>×Mult</th>
                  <th>Pots 250</th>
                  <th>Pots 350</th>
                  <th>Rendement réel</th>
                  <th>Yield</th>
                </tr>
              </thead>
              <tbody>
                {historique.map(b => {
                  const y = parseFloat(b.yield_sauce);
                  const yColor = y >= 90 ? 'var(--success)' : y >= 75 ? 'var(--warning)' : 'var(--danger)';
                  return (
                    <tr key={b.id}>
                      <td style={{ fontWeight: 600 }}>{b.nom}</td>
                      <td className="muted">{b.date_prod}</td>
                      <td>×{b.multiplicateur || 1}</td>
                      <td>{b.nb_pots_250 || 0}</td>
                      <td>{b.nb_pots_350 || 0}</td>
                      <td>{b.rendement_reel_ml ? `${b.rendement_reel_ml} ml` : '—'}</td>
                      <td>
                        {y ? (
                          <span style={{ color: yColor, fontWeight: 600, fontFeatureSettings: "'tnum' 1" }}>{y.toFixed(1)}%</span>
                        ) : '—'}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
